
<template>
  	<Navbar/>
</template>

<!-- // // // //  -->

<script>
import Navbar from './components/layout.vue'

export default {
  name: 'app_navbar',
  components: {
    Navbar
  }
}
</script>





// WEBPACK FOOTER //
// src/containers/app_navbar/index.vue